module.exports = __webpack_public_path__ + "static/media/car.99f0dbf0.svg";